
var name = "name";
var firstName = "firstName";
var lastName = "lastName";
var email="email";
var contactNumber="contactNumber";
var user="user";
var authToken="authToken";
var profile="profile";
var applyJob="clickapplybutton";
var page="page";
var jobId="jobId";
var falvor="flavor";
var templateName="templateName";
var peerRatingId="peerRatingId";

var reviewerName="reviewerName";
var reviewerLastName="reviewerLastName";
var reviewerEmail="reviewerEmail";
var reviewercontactNumber="reviewercontactNumber";
var candidateId="candidateId";
var jobStatus="jobStatus";
var isFromWizard="isFromWizard";
export const StorageValues = {
    NAME: name,
    FIRSTNAME :firstName,
    LASTNAME: lastName,
    EMAIL: email,
    CONTACT_NUMBER: contactNumber,
    USER:user,
    AUTH_TOKEN:authToken,
    PROFILE: profile,
    APPLY_JOB:applyJob,
    PAGE:page,
    JOB_ID:jobId,
    FLAVOR: falvor,
    TEMPLATE_NAME: templateName,
    PEER_RATING_ID: peerRatingId,
    REVIEWER_NAME:reviewerName,
    REVIEWER_LAST_NAME:reviewerLastName,
    REVIEWER_EMAIL:reviewerEmail,
    REVIEWER_CONTACT_NUMBER:reviewercontactNumber,
    CANDIDATE_ID:candidateId,
    jobStatus:jobStatus,
    isFromWizard:isFromWizard,   
    


}